import { render } from "./UploadComponent.vue?vue&type=template&id=b0f598ce&scoped=true&ts=true"
import script from "./UploadComponent.vue?vue&type=script&lang=ts"
export * from "./UploadComponent.vue?vue&type=script&lang=ts"

import "./UploadComponent.vue?vue&type=style&index=0&id=b0f598ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0f598ce"]])

export default __exports__